import React, { useEffect, useState, useContext } from 'react';

const Tracker = () => {
  let underlying = null;
  const pending = [];
  return {
    underlying: () => underlying,
    trackPageView: title => {
      if (underlying) {
        underlying.trackPageView(title);
      } else {
        pending.push(tracker => tracker.trackPageView(title));
      }
    },
    setUnderlying: tracker => {
      if (!underlying) {
        pending.forEach(fn => fn(tracker));
        underlying = tracker;
      }
    },
    trackEvent: (category, action, value) => {
      if (underlying) {
        underlying.trackEvent(category, action, value);
      } else {
        pending.push(tracker => tracker.trackEvent(category, action, value));
      }
    },
    trackGoal: (idGoal, customRevenue) => {
      if (underlying) {
        underlying.trackGoal(idGoal, customRevenue);
      } else {
        pending.push(tracker => tracker.trackGoal(idGoal, customRevenue));
      }
    }
  };
};
const MatomoContext = React.createContext(null);
const TrackPageView = () => {
  const tracker = useContext(MatomoContext);
  useEffect(() => {
    if (tracker.underlying()) {
      tracker.underlying().setCustomUrl(window.location);
      tracker.underlying().setDocumentTitle(document.title);
    }
    tracker.trackPageView();
  }, [tracker]);
  return null;
};
const MatomoLoader = ({ url, siteId }) => {
  const tracker = useContext(MatomoContext);
  useEffect(() => {
    const existingMatomoJs = document.getElementById('matomo-js');
    if (!existingMatomoJs) {
      const matomoJs = document.createElement('script');
      matomoJs.type = 'text/javascript';
      matomoJs.src = 'https://cdn.matomo.cloud/yupwego.matomo.cloud/matomo.js';
      matomoJs.id = 'matomo-js';
      matomoJs.onload = () => {
        if (typeof window.Matomo === 'object') {
          const underlying = window.Matomo.addTracker(
            url + 'matomo.php',
            siteId
          );
          const time = Math.round(new Date() / 1e3);
          const visitorInfo = underlying.getVisitorInfo();
          underlying.setVisitorCookieTimeout(
            parseInt(visitorInfo[2]) + 33696e3 - time
          );
          underlying.enableHeartBeatTimer();
          underlying.enableLinkTracking();
          underlying.setSecureCookie(true);
          underlying.setDoNotTrack(true);
          tracker.setUnderlying(underlying);
        }
      };
      document.body.appendChild(matomoJs);
    }
  }, [siteId, tracker, url]);
  return null;
};
const MatomoAsyncProvider = ({ url, siteId, children }) => {
  const [tracker] = useState(Tracker());

  return (
    <MatomoContext.Provider value={tracker}>
      {children}
      <MatomoLoader url={url} siteId={siteId} />
    </MatomoContext.Provider>
  );
};

MatomoAsyncProvider.Context = MatomoContext;
export default MatomoAsyncProvider;
export { TrackPageView };
